<template>
  <div>
    <div v-if="isScrolled9">
      <Header1 />
    </div>

    <div>
      <!-- 行业banner -->
      <div class="industrybanner">
        <div class="bag baseimg">
          <img
            :src="require('@/assets/newImage/1-2301111K250621.png')"
            alt=""
          />
        </div>
        <div class="cont">
          <div class="basecont">
            <h2 class="tit basefont38">{{$t('message.newsBannerTitle')}}</h2>
            <div class="basefont26">{{$t('message.newsBannerDesc')}}</div>
            <div class="but">
              <router-link to="/contact/" class="fz_but">{{$t('message.contactForApi')}}</router-link>
            </div>
            <!--链接调用	<a href="/contact/">-->
          </div>
        </div>
      </div>
      <!-- 技术特点 -->
      <div class="industrybox-sec1">
        <div class="basecont">
          <div class="fz_tit basefont38">{{ $t('message.techFeatures') }}</div>
          <div class="cont">
            <div
              class="item"
              v-for="item in techFeatures.archiveList"
              :key="item.id"
            >
              <div class="list">
                <i>
                  <img
                    :src="
                      item.aid === 193 ? require('@/assets/newImage/1-230109141505191.png') :
                      item.aid === 194 ? require('@/assets/newImage/1-23010914161S54.png') :
                      item.aid === 195 ? require('@/assets/newImage/1-230109141634601.png') :
                      item.aid === 196 ? require('@/assets/newImage/1-230109141A13Y.png') : ''
                    "
                    alt=""
                  />
                </i>
                <div class="tit">{{ 
                  item.title === 'efficientConvenient' ? $t('message.efficientConvenient') :
                  item.title === 'safeStable' ? $t('message.safeStable') :
                  item.title === 'powerfulAlgorithm' ? $t('message.powerfulAlgorithm') :
                  item.title === 'multiLanguageSupport' ? $t('message.multiLanguageSupport') : item.title
                }}</div>
                <div class="text">
                  <p v-html="
                    item.title === 'efficientConvenient' ? $t('message.efficientConvenientDesc') :
                    item.title === 'safeStable' ? $t('message.safeStableDesc') :
                    item.title === 'powerfulAlgorithm' ? $t('message.powerfulAlgorithmDesc') :
                    item.title === 'multiLanguageSupport' ? $t('message.multiLanguageSupportDesc') : item.seoDescription
                  "></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 技术优势 和 技术原理 -->
      <div class="industrybox-sec2">
        <div class="basecont">
          <!-- 技术优势 -->
          <div class="item">
            <div class="lt">
              <div class="tit basefont38">{{ $t('message.techAdvantages') }}</div>
              <div class="jut">
                <div v-html="$t('message.techAdvantagesDesc')"></div>
              </div>
            </div>
            <div class="img">
              <img
                :src="require('@/assets/newImage/1-230109142523919.png')"
                alt=""
              />
            </div>
          </div>
          <!-- 技术原理 -->
          <div class="item">
            <div class="lt">
              <div class="tit basefont38">{{ $t('message.techPrinciples') }}</div>
              <div class="jut">
                <p v-html="$t('message.techPrinciplesDesc')"></p>
              </div>
            </div>
            <div class="img">
              <img
                :src="require('@/assets/newImage/1-230109142634Q7.png')"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 压缩内容 -->
      <div class="industrybox-sec3">
        <!-- 图像压缩sdk -->
        <div
          class="fz_jut"
          :style="{ backgroundImage: 'url(' + require('@/assets/newImage/1-230109144252P8.jpg') + ')' }"
        >
          <div class="basecont">
            <div class="fz_tit basefont38">{{ $t('message.imageCompressSdk') }}</div>
            <div class="cont">
              <div
                class="item"
                v-for="(item, index) in imageSdk.archiveList"
                :key="index"
              >
                <div class="list">
                  <div class="tit">{{ 
                    item.title === 'supportedFormats' ? $t('message.supportedFormats') :
                    item.title === 'painPoints' ? $t('message.painPoints') :
                    item.title === 'featuresEffects' ? $t('message.featuresEffects') :
                    item.title === 'suitableScenarios' ? $t('message.suitableScenarios') : item.title
                  }}</div>
                  <div class="text">
                    <div v-html="
                      item.title === 'supportedFormats' ? $t('message.supportedFormatsImage') :
                      item.title === 'painPoints' ? $t('message.painPointsImage') :
                      item.title === 'featuresEffects' ? $t('message.featuresEffectsImage') :
                      item.title === 'suitableScenarios' ? $t('message.suitableScenariosImage') : item.describe
                    "></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="but">
              <a
                href="https://www.yasubit.com/uploads/soft/20230113/1-23011314251X94.pdf"
                class="fz_but"
              >
                <span>{{$t('message.getDoc')}}</span>
              </a>
            </div>
          </div>
        </div>
        <!-- 医疗影像压缩sdk -->
        <div
          class="fz_jut"
          :style="{ backgroundImage: 'url(' + require('@/assets/newImage/1-230109150624D8.jpg') + ')' }"
        >
          <div class="basecont">
            <div class="fz_tit basefont38">{{ $t('message.medicalImageSdk') }}</div>
            <div class="cont">
              <div
                class="item"
                v-for="(item, index) in medicalVideoSdk.archiveList"
                :key="index"
              >
                <div class="list">
                  <div class="tit">{{ 
                    item.title === 'supportedFormats' ? $t('message.supportedFormats') :
                    item.title === 'painPoints' ? $t('message.painPoints') :
                    item.title === 'featuresEffects' ? $t('message.featuresEffects') :
                    item.title === 'suitableScenarios' ? $t('message.suitableScenarios') : item.title
                  }}</div>
                  <div class="text">
                    <div v-html="
                      item.title === 'supportedFormats' ? $t('message.supportedFormatsMedical') :
                      item.title === 'painPoints' ? $t('message.painPointsMedical') :
                      item.title === 'featuresEffects' ? $t('message.featuresEffectsMedical') :
                      item.title === 'suitableScenarios' ? $t('message.suitableScenariosMedical') : item.describe
                    "></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="but">
              <a
                href="https://www.yasubit.com/uploads/soft/20230113/1-230113142539548.pdf"
                class="fz_but"
              >
                <span>{{$t('message.getDoc')}}</span>
              </a>
            </div>
          </div>
        </div>
        <!-- 文本&log压缩SDK -->
        <div
          class="fz_jut"
          :style="{ backgroundImage: 'url(' + require('@/assets/newImage/1-230109154133945.png') + ')' }"
        >
          <div class="basecont">
            <div class="fz_tit basefont38">{{ $t('message.textLogSdk') }}</div>
            <div class="cont">
              <div
                class="item"
                style="text-align: left"
                v-for="(item, index) in logSdk.archiveList"
                :key="index"
              >
                <div class="list">
                  <div class="tit">{{ 
                    item.title === 'supportedFormats' ? $t('message.supportedFormats') :
                    item.title === 'painPoints' ? $t('message.painPoints') :
                    item.title === 'featuresEffects' ? $t('message.featuresEffects') :
                    item.title === 'suitableScenarios' ? $t('message.suitableScenarios') : item.title
                  }}</div>
                  <div class="text">
                    <div v-html="
                      item.title === 'supportedFormats' ? $t('message.supportedFormatsText') :
                      item.title === 'painPoints' ? $t('message.painPointsText') :
                      item.title === 'featuresEffects' ? $t('message.featuresEffectsText') :
                      item.title === 'suitableScenarios' ? $t('message.suitableScenariosText') : item.describe
                    "></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="but">
              <a
                href="https://www.yasubit.com/uploads/soft/20230113/1-230113142600464.pdf"
                class="fz_but"
              >
                <span>{{$t('message.getDoc')}}</span>
              </a>
            </div>
          </div>
        </div>
        <!-- 视频流实时压缩SDK -->
        <div
          class="fz_jut"
          :style="{ backgroundImage: 'url(' + require('@/assets/newImage/1-2301091551023T.jpg') + ')' }"
        >
          <div class="basecont">
            <div class="fz_tit basefont38">{{ $t('message.videoStreamSdk') }}</div>
            <div class="cont">
              <div
                class="item"
                v-for="(item, index) in videoSdk.archiveList"
                :key="index"
              >
                <div class="list">
                  <div class="tit">{{ 
                    item.title === 'supportedFormats' ? $t('message.supportedFormats') :
                    item.title === 'painPoints' ? $t('message.painPoints') :
                    item.title === 'featuresEffects' ? $t('message.featuresEffects') :
                    item.title === 'suitableScenarios' ? $t('message.suitableScenarios') : item.title
                  }}</div>
                  <div class="text">
                    <div v-html="
                      item.title === 'supportedFormats' ? $t('message.supportedFormatsVideo') :
                      item.title === 'painPoints' ? $t('message.painPointsVideo') :
                      item.title === 'featuresEffects' ? $t('message.featuresEffectsVideo') :
                      item.title === 'suitableScenarios' ? $t('message.suitableScenariosVideo') : item.describe
                    "></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="but">
              <a @click="scrollToTop" class="fz_but">
                <span>{{$t('message.getDoc')}}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header1 from "@/views/header1.vue";
import Header from "@/views/header.vue";
import Banner from "../components/Banner";
import Footer from "@/views/footer.vue";
export default {
  components: {
    Header1,
    Header,
    Banner,
    Footer,
  },
  created() {
    document.title = this.$t('message.newsBannerTitle') + '_智慧林';
  },

  data() {
    return {
      isScrolled9: true,
      loading: true,
      caseList: [],
      data: [],
      techFeatures: [],
      techAdvantages: undefined,
      techPrinciples: undefined,
      imageSdk: undefined,
      medicalVideoSdk: undefined,
      logSdk: undefined,
      videoSdk: undefined,
      staticData: {
    "msg": "操作成功",
    "code": 200,
    "data": [
        {
            "id": 145,
            "parentId": 0,
            "typename": "行业应用",
            "title": null,
            "isHidden": 0,
            "sortOrder": 2,
            "position": "1",
            "categoryId": 1,
            "categoryParentId": null,
            "newCategory": null,
            "children": [
                {
                    "id": 147,
                    "parentId": 145,
                    "typename": "技术特点",
                    "title": null,
                    "isHidden": 0,
                    "sortOrder": 1000,
                    "position": null,
                    "categoryId": null,
                    "categoryParentId": null,
                    "newCategory": null,
                    "children": [],
                    "archiveList": [
                        {
                            "aid": 193,
                            "typeid": 147,
                            "channel": 104,
                            "isB": 0,
                            "title": "efficientConvenient",
                            "litpic": "/uploads/allimg/20230109/1-230109141505191.png",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 1,
                            "author": "admin",
                            "click": 112,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "efficientConvenientDesc",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673244873,
                            "updateTime": 1700101583,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "<p> </p>",
                            "content": "<p> </p>"
                        },
                        {
                            "aid": 194,
                            "typeid": 147,
                            "channel": 104,
                            "isB": 0,
                            "title": "safeStable",
                            "litpic": "/uploads/allimg/20230109/1-23010914161S54.png",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 1,
                            "author": "admin",
                            "click": 121,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "safeStableDesc",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673244909,
                            "updateTime": 1673244909,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": null,
                            "content": null
                        },
                        {
                            "aid": 195,
                            "typeid": 147,
                            "channel": 104,
                            "isB": 0,
                            "title": "powerfulAlgorithm",
                            "litpic": "/uploads/allimg/20230109/1-230109141634601.png",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 1,
                            "author": "admin",
                            "click": 272,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "powerfulAlgorithmDesc",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673244982,
                            "updateTime": 1673244982,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": null,
                            "content": null
                        },
                        {
                            "aid": 196,
                            "typeid": 147,
                            "channel": 104,
                            "isB": 0,
                            "title": "multiLanguageSupport",
                            "litpic": "/uploads/allimg/20230109/1-230109141A13Y.png",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 1,
                            "author": "admin",
                            "click": 273,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "multiLanguageSupportDesc",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673245003,
                            "updateTime": 1673429814,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "<p>11</p>",
                            "content": "<p>11</p>"
                        }
                    ]
                },
                {
                    "id": 149,
                    "parentId": 145,
                    "typename": "优势+原理",
                    "title": null,
                    "isHidden": 0,
                    "sortOrder": 1000,
                    "position": null,
                    "categoryId": null,
                    "categoryParentId": null,
                    "newCategory": null,
                    "children": [],
                    "archiveList": [
                        {
                            "aid": 197,
                            "typeid": 149,
                            "channel": 104,
                            "isB": 0,
                            "title": "techAdvantages",
                            "litpic": "/uploads/allimg/20230109/1-230109142523919.png",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 1,
                            "author": "admin",
                            "click": 113,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "techAdvantagesDesc",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673245492,
                            "updateTime": 1673255829,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": null,
                            "content": null
                        },
                        {
                            "aid": 198,
                            "typeid": 149,
                            "channel": 104,
                            "isB": 0,
                            "title": "techPrinciples",
                            "litpic": "/uploads/allimg/20230109/1-230109142634Q7.png",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 1,
                            "author": "admin",
                            "click": 182,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "techPrinciplesDesc",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673245580,
                            "updateTime": 1673245580,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": null,
                            "content": null
                        }
                    ]
                },
                {
                    "id": 151,
                    "parentId": 145,
                    "typename": "图片压缩SDK",
                    "title": null,
                    "isHidden": 0,
                    "sortOrder": 1000,
                    "position": null,
                    "categoryId": null,
                    "categoryParentId": null,
                    "newCategory": null,
                    "children": [],
                    "archiveList": [
                        {
                            "aid": 199,
                            "typeid": 151,
                            "channel": 104,
                            "isB": 0,
                            "title": "supportedFormats",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 257,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "supportedFormatsImage",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673246421,
                            "updateTime": 1676540623,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "supportedFormatsImage",
                            "content": null
                        },
                        {
                            "aid": 200,
                            "typeid": 151,
                            "channel": 104,
                            "isB": 0,
                            "title": "painPoints",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 127,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "painPointsImage",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673246446,
                            "updateTime": 1676517814,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "painPointsImage",
                            "content": null
                        },
                        {
                            "aid": 201,
                            "typeid": 151,
                            "channel": 104,
                            "isB": 0,
                            "title": "featuresEffects",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 248,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "featuresEffectsImage",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673246470,
                            "updateTime": 1676517912,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "featuresEffectsImage",
                            "content": null
                        },
                        {
                            "aid": 202,
                            "typeid": 151,
                            "channel": 104,
                            "isB": 0,
                            "title": "suitableScenarios",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 155,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673246494,
                            "updateTime": 1676542241,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "suitableScenariosImage",
                            "content": null
                        }
                    ]
                },
                {
                    "id": 153,
                    "parentId": 145,
                    "typename": "图片压缩SDK两个下载",
                    "title": null,
                    "isHidden": 0,
                    "sortOrder": 1000,
                    "position": null,
                    "categoryId": null,
                    "categoryParentId": null,
                    "newCategory": null,
                    "children": [],
                    "archiveList": [
                        {
                            "aid": 204,
                            "typeid": 153,
                            "channel": 104,
                            "isB": 0,
                            "title": "获取说明文档",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 190,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673247472,
                            "updateTime": 1673591121,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": null,
                            "content": null
                        }
                    ]
                },
                {
                    "id": 155,
                    "parentId": 145,
                    "typename": "医疗影像压缩SDK",
                    "title": null,
                    "isHidden": 0,
                    "sortOrder": 1000,
                    "position": null,
                    "categoryId": null,
                    "categoryParentId": null,
                    "newCategory": null,
                    "children": [],
                    "archiveList": [
                        {
                            "aid": 205,
                            "typeid": 155,
                            "channel": 104,
                            "isB": 0,
                            "title": "supportedFormats",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 261,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "supportedFormatsMedical",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673248017,
                            "updateTime": 1676540845,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "supportedFormatsMedical",
                            "content": null
                        },
                        {
                            "aid": 206,
                            "typeid": 155,
                            "channel": 104,
                            "isB": 0,
                            "title": "painPoints",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 134,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "painPointsMedical",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673248050,
                            "updateTime": 1673248050,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "painPointsMedical",
                            "content": null
                        },
                        {
                            "aid": 207,
                            "typeid": 155,
                            "channel": 104,
                            "isB": 0,
                            "title": "featuresEffects",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 196,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "featuresEffectsMedical",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673248177,
                            "updateTime": 1676540042,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "featuresEffectsMedical",
                            "content": null
                        },
                        {
                            "aid": 208,
                            "typeid": 155,
                            "channel": 104,
                            "isB": 0,
                            "title": "suitableScenarios",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 265,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673248196,
                            "updateTime": 1676512709,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "suitableScenariosMedical",
                            "content": null
                        }
                    ]
                },
                {
                    "id": 157,
                    "parentId": 145,
                    "typename": "医疗影像压缩SDK两个下载",
                    "title": null,
                    "isHidden": 0,
                    "sortOrder": 1000,
                    "position": null,
                    "categoryId": null,
                    "categoryParentId": null,
                    "newCategory": null,
                    "children": [],
                    "archiveList": [
                        {
                            "aid": 210,
                            "typeid": 157,
                            "channel": 104,
                            "isB": 0,
                            "title": "获取说明文档",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 170,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673248601,
                            "updateTime": 1673591142,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": null,
                            "content": null
                        }
                    ]
                },
                {
                    "id": 159,
                    "parentId": 145,
                    "typename": "文本&amp;log压缩SDK",
                    "title": null,
                    "isHidden": 0,
                    "sortOrder": 1000,
                    "position": null,
                    "categoryId": null,
                    "categoryParentId": null,
                    "newCategory": null,
                    "children": [],
                    "archiveList": [
                        {
                            "aid": 211,
                            "typeid": 159,
                            "channel": 104,
                            "isB": 0,
                            "title": "supportedFormats",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 214,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "supportedFormatsText",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673250114,
                            "updateTime": 1676540749,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "supportedFormatsText",
                            "content": null
                        },
                        {
                            "aid": 212,
                            "typeid": 159,
                            "channel": 104,
                            "isB": 0,
                            "title": "painPoints",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 193,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "painPointsText",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673250144,
                            "updateTime": 1676542151,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "painPointsText",
                            "content": null
                        },
                        {
                            "aid": 213,
                            "typeid": 159,
                            "channel": 104,
                            "isB": 0,
                            "title": "featuresEffects",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 290,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "featuresEffectsText",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673250162,
                            "updateTime": 1676517183,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "featuresEffectsText",
                            "content": null
                        },
                        {
                            "aid": 214,
                            "typeid": 159,
                            "channel": 104,
                            "isB": 0,
                            "title": "suitableScenarios",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 221,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673250186,
                            "updateTime": 1676542218,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "suitableScenariosText",
                            "content": null
                        }
                    ]
                },
                {
                    "id": 161,
                    "parentId": 145,
                    "typename": "文本&amp;log压缩SDK两个下载",
                    "title": null,
                    "isHidden": 1,
                    "sortOrder": 1000,
                    "position": null,
                    "categoryId": null,
                    "categoryParentId": null,
                    "newCategory": null,
                    "children": [],
                    "archiveList": [
                        {
                            "aid": 216,
                            "typeid": 161,
                            "channel": 104,
                            "isB": 0,
                            "title": "获取说明文档",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 170,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673250626,
                            "updateTime": 1673591163,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": null,
                            "content": null
                        }
                    ]
                },
                {
                    "id": 163,
                    "parentId": 145,
                    "typename": "视频流实时压缩SDK",
                    "title": null,
                    "isHidden": 1,
                    "sortOrder": 1000,
                    "position": null,
                    "categoryId": null,
                    "categoryParentId": null,
                    "newCategory": null,
                    "children": [],
                    "archiveList": [
                        {
                            "aid": 217,
                            "typeid": 163,
                            "channel": 104,
                            "isB": 0,
                            "title": "supportedFormats",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 187,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "supportedFormatsVideo",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673250669,
                            "updateTime": 1676540762,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "supportedFormatsVideo",
                            "content": null
                        },
                        {
                            "aid": 218,
                            "typeid": 163,
                            "channel": 104,
                            "isB": 0,
                            "title": "painPoints",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 102,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "painPointsVideo",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673250797,
                            "updateTime": 1673250797,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "painPointsVideo",
                            "content": null
                        },
                        {
                            "aid": 219,
                            "typeid": 163,
                            "channel": 104,
                            "isB": 0,
                            "title": "featuresEffects",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 219,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "<p>金融、数据中心、边缘计算等、区块链、物联网等。安防监控、120急救车、指挥中心智慧交通等。</p>",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673251124,
                            "updateTime": 1676542227,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": "<p><span style=\"color: rgb(153, 153, 153);\">安防监控、120急救车、指挥中心智慧交通等</span></p>",
                            "content": null
                        }
                    ]
                },
                {
                    "id": 165,
                    "parentId": 145,
                    "typename": " 视频流实时压缩SDK两个下载",
                    "title": null,
                    "isHidden": 1,
                    "sortOrder": 1000,
                    "position": null,
                    "categoryId": null,
                    "categoryParentId": null,
                    "newCategory": null,
                    "children": [],
                    "archiveList": [
                        {
                            "aid": 242,
                            "typeid": 165,
                            "channel": 0,
                            "isB": 0,
                            "title": "超级无敌牛哇",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "",
                            "click": 0,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "<p>超级无敌牛哇1</p>",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 0,
                            "lang": "cn",
                            "adminId": 0,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1703240725,
                            "updateTime": 0,
                            "isNew": null,
                            "isHot": null,
                            "letter": null,
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": null,
                            "content": null
                        },
                        {
                            "aid": 222,
                            "typeid": 165,
                            "channel": 104,
                            "isB": 0,
                            "title": "获取说明文档",
                            "litpic": "",
                            "isHead": 0,
                            "isSpecial": 0,
                            "isTop": 0,
                            "isRecom": 0,
                            "isJump": 0,
                            "isLitpic": 0,
                            "author": "admin",
                            "click": 170,
                            "arcrank": 0,
                            "jumplinks": "",
                            "ismake": 0,
                            "seoTitle": "",
                            "seoKeywords": "",
                            "seoDescription": "",
                            "attrlistId": "0",
                            "usersPrice": 0.00,
                            "usersFree": "0",
                            "oldPrice": 0.00,
                            "salesNum": "0",
                            "stockCount": "0",
                            "stockShow": "1",
                            "promType": "0",
                            "tempview": "",
                            "status": 1,
                            "sortOrder": 100,
                            "lang": "cn",
                            "adminId": 1,
                            "usersId": 0,
                            "arcLevelId": 0,
                            "isDel": 0,
                            "delMethod": 0,
                            "joinaid": 0,
                            "downcount": 0,
                            "htmlfilename": "",
                            "addTime": 1673251250,
                            "updateTime": 1673255946,
                            "isNew": null,
                            "isHot": null,
                            "letter": "",
                            "fabulous": 0,
                            "heart": 0,
                            "heartUsers": "",
                            "fabulousUsers": null,
                            "isHiddel": 1,
                            "day": null,
                            "discount": null,
                            "describe": null,
                            "content": null
                        }
                    ]
                }
            ],
            "archiveList": [
                {
                    "aid": 246,
                    "typeid": 145,
                    "channel": 0,
                    "isB": 0,
                    "title": "jishu",
                    "litpic": "",
                    "isHead": 0,
                    "isSpecial": 0,
                    "isTop": 0,
                    "isRecom": 0,
                    "isJump": 0,
                    "isLitpic": 0,
                    "author": "",
                    "click": 0,
                    "arcrank": 0,
                    "jumplinks": "",
                    "ismake": 0,
                    "seoTitle": "",
                    "seoKeywords": "",
                    "seoDescription": "<p>tes</p>",
                    "attrlistId": "0",
                    "usersPrice": 0.00,
                    "usersFree": "0",
                    "oldPrice": 0.00,
                    "salesNum": "0",
                    "stockCount": "0",
                    "stockShow": "1",
                    "promType": "0",
                    "tempview": "",
                    "status": 1,
                    "sortOrder": 0,
                    "lang": "cn",
                    "adminId": 0,
                    "usersId": 0,
                    "arcLevelId": 0,
                    "isDel": 0,
                    "delMethod": 0,
                    "joinaid": 0,
                    "downcount": 0,
                    "htmlfilename": "",
                    "addTime": 1703844359,
                    "updateTime": 0,
                    "isNew": null,
                    "isHot": null,
                    "letter": null,
                    "fabulous": 0,
                    "heart": 0,
                    "heartUsers": "",
                    "fabulousUsers": null,
                    "isHiddel": 1,
                    "day": null,
                    "discount": null,
                    "describe": "<p>tt</p>",
                    "content": "<p>tttt</p>"
                }
            ]
        }
    ]
}
    };
  },

  methods: {
    scrollToTop(event) {
      event.preventDefault(); // 阻止默认跳转行为
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    handleScroll9() {
      // console.log(98989898)
      // 获取当前滚动位置
      const scrollY = window.scrollY || window.pageYOffset;

      // 可以设置一个阈值来确定何时改变isScrolled9的值
      const dis = 100;

      // 判断滚动位置是否大于阈值
      if (scrollY > dis) {
        // 向下滚动，将isScrolled9设为false
        this.isScrolled9 = false;
      } else {
        // 向上滚动，将isScrolled9设为true
        this.isScrolled9 = true;
      }
      // const scrollDistance = window.scrollY || document.documentElement.scrollTop;
      // // 当滚动距离小于等于200px时，设置isScrolled9为true
      // this.isScrolled9 = scrollDistance <=500;
    },
    parse() {
      // 技术特点
      this.techFeatures = this.data.find((item) => item.id === 147);
      // 技术优势
      this.techAdvantages = this.data.find(
        (item) => item.id === 149
      ).archiveList[0];
      // 技术原理
      this.techPrinciples = this.data.find(
        (item) => item.id === 149
      ).archiveList[1];
      // 图片压缩sdk
      this.imageSdk = this.data.find((item) => item.id === 151);
      // 医疗影像压缩sdk
      this.medicalVideoSdk = this.data.find((item) => item.id === 155);
      // 文本 log 压缩sdk
      this.logSdk = this.data.find((item) => item.id === 159);
      // 视频流压缩sdk
      this.videoSdk = this.data.find((item) => item.id === 163);
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll9);
    window.console.log("case");
    // 直接使用静态数据
    this.data = this.staticData.data[0].children;
    this.parse();
  },
};
</script>

<style lang="scss" scoped>
.between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.center {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}
.one-third {
  width: 33.333333%;
  height: 50px;
  background-color: pink;
}
.one-five {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  flex-direction: column;
  width: 20%;
  height: 50px;
}

.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-image: url("../../src/assets/img/t1.png"); /* 替换 'your-image.jpg' 为你的背景图片路径 */
  //background-size: auto 50%; /* 背景图片宽度自适应，高度占据50% */
  background-repeat: no-repeat;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>
